import { GenericValue } from 'hisng';

export class GlobalIdentifier {
    id: number;
    identifier: string;
    tabpk: number;
    globalIdentifierType: GenericValue;
    lockVersion: number;

    constructor( id?: number, globalIdentifierType?: GenericValue, identifier?: string ) {
        this.id = id;
        this.globalIdentifierType = globalIdentifierType;
        this.identifier = identifier;
    }
}
